import Color from '@base/features/game/model/color';
import Checker from './checker';

export default class CheckerStack {
  public checkers: Checker[] = [];
  constructor(private num: number) {}

  getNumber() {
    return this.num;
  }

  getCheckersCount() {
    return this.checkers.length;
  }

  getCheckers() {
    return this.checkers;
  }

  attachChecker(checker: Checker) {
    this.checkers.push(checker);
  }

  detachChecker() {
    if (this.checkers.length === 0) {
      throw new Error('no checkers in stack');
    }
    const checker = this.checkers[0];
    this.checkers.splice(0, 1);
    return checker;
  }

  getCheckersColor() {
    if (this.checkers.length > 0) {
      return this.checkers[0].getColor();
    } else {
      return null;
    }
  }

  topChecker() {
    if (this.checkers.length === 0) return null;

    const checker = this.checkers[this.checkers.length - 1];
    return checker;
  }

  clear() {
    while (this.checkers.length) {
      this.checkers.pop();
    }
  }

  toString() {
    let colVal = '';
    if (this.checkers.length > 0) {
      if (this.checkers[0].getColor() === Color.White) {
        colVal = 'W';
      } else {
        colVal = 'R';
      }
    }
    return this.checkers.length.toString() + colVal;
  }

  addCheckers(color: Color, count: number) {
    while (this.checkers.length) {
      this.checkers.pop();
    }

    for (let i = 0; i < count; i++) {
      const checker = new Checker(color, this.num);
      this.checkers.push(checker);
    }
  }
}
